import React from 'react';

export interface BlockRendererProps {
  block: { settings: Record<string, any> };
  config: {
    anaRenk: string;
    aksanRenk: string;
    font: string;
    fontBoyutu: number;
    odemeKosullari?: string;
    gecerlilikNotu?: string;
    altBilgiNotu?: string;
  };
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const formatDate = (dateString: string | undefined): string => {
  if (!dateString) return '-';
  try {
    if (dateString.includes('T')) {
      const [d] = dateString.split('T');
      const [y, m, day] = d.split('-');
      return `${day}.${m}.${y}`;
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return new Intl.DateTimeFormat('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
  } catch { return dateString; }
};

const GreetingBlockRenderer: React.FC<BlockRendererProps> = ({ block, config, offer, offerType }) => {
  const s = block?.settings ?? {};
  const text = typeof s.text === 'string' ? s.text : '';
  const showDate = s.showDate === true;
  const dateStr = offer?.date ? formatDate(String(offer.date)) : '-';
  const isGiven = offerType !== 'received';

  return (
    <div style={{ fontFamily: `'${config.font}', Arial, sans-serif`, fontSize: `${config.fontBoyutu}px`, color: '#333', lineHeight: 1.55 }}>
      <div style={{ fontWeight: 700, marginBottom: 8, letterSpacing: '0.02em' }}>
        {isGiven ? 'SAYIN YETKİLİ,' : 'SAYIN TEDARİKÇİ FİRMA YETKİLİSİ,'}
      </div>
      {text ? <div style={{ whiteSpace: 'pre-wrap', marginBottom: showDate ? 10 : 0 }}>{text}</div> : null}
      {showDate ? (
        <div style={{ color: '#555' }}><span style={{ fontWeight: 600 }}>Tarih: </span>{dateStr}</div>
      ) : null}
    </div>
  );
};

export default GreetingBlockRenderer;
